import { IHttpClient } from '@common/clients/http/http.client.interface';
import { toCamelKeys } from '@common/utils/format.util';
import {
  GetEnglishTranslationOptionListRes,
  RawGetEnglishTranslationOptionListRes,
} from '@master/models/get-english-translation-option-list.model';
import {
  GetSubjectUniversityOptionListRes,
  RawGetSubjectUniversityOptionListRes,
} from '../models/get-subject-university-option-list.model';
import IMasterRepository from './master.repository.interface';

export default function masterRepositoryImpl(httpClient: IHttpClient): IMasterRepository {
  const getSubjectUniversityOptionList = async (
    signal?: AbortSignal,
  ): Promise<GetSubjectUniversityOptionListRes> => {
    const response = await httpClient.get<RawGetSubjectUniversityOptionListRes>('/api/options', {
      signal,
    });

    return toCamelKeys(response);
  };

  const getEnglishTranslationOptionList = async (
    signal?: AbortSignal,
  ): Promise<GetEnglishTranslationOptionListRes> => {
    const response = await httpClient.get<RawGetEnglishTranslationOptionListRes>(
      '/api/translation_options',
      { signal },
    );

    return toCamelKeys(response);
  };

  return { getEnglishTranslationOptionList, getSubjectUniversityOptionList };
}
